import forage from 'localforage'

export const fTable = forage.createInstance({
  name: 'crms-table',
  storeName: 'asm',
  driver: [
    forage.INDEXEDDB,
    forage.LOCALSTORAGE
  ]
})

const setTableOptions = ({ currentPage, perPage, sortBy, sortDesc, filter, totalRows }) => {
  return fTable.setItem('r-officer-other-events', {
    currentPage,
    perPage,
    sortBy,
    sortDesc,
    totalRows,
    filter: {
      province: '',
      municipality: '',
      status: 'All',
      search: filter.search,
      month: filter.month,
      officer: filter.officer,
      activity: filter.activity
    }
  })
}

const getTableOptions = async () => {
  return await fTable.getItem('r-officer-other-events')
}

export {
  setTableOptions,
  getTableOptions
}
